import Link from 'next/link';
import { useRouter } from 'next/router';
import React from 'react';
import styled from 'styled-components';
import { DefaultFont } from '../../styles/themes';

export const HelpWrapper = ({ children }: any) => {
  const router = useRouter();
  let basepath = '/learn/';
  if (router.pathname.includes('notes')) {
    basepath = '/notes/help/';
  }
  return (
    <HelpWrapperContainer>
      {router.asPath !== '/notes/editor' ? (
        <Link href={basepath}>Back to help articles</Link>
      ) : null}
      {children}
    </HelpWrapperContainer>
  );
};

const HelpWrapperContainer = styled.div`
  margin: auto;
  max-width: 900px;
  font-family: ${DefaultFont};

  line-height: 1.5;
  & p {
    font-size: 1.2rem;
  }
  & h1 {
    font-size: 1.9rem;
  }
  & h2 {
    font-size: 1.55rem;
  }
  & h3 {
    font-size: 1.3rem;
  }
`;
